import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Folder } from '../../core-data-model/Folder.model';
import { ContextDataService } from '../../core-services/Context.dataservice';
import { TranslationService } from '../../translations';

@Component({
    selector: 'folder-select-modal-button',
    template: `
        <i
            class="btn-icon fa fa-folder"
            style="font-size: 14px;"
            (click)="onClick()"
        >
        </i>

        @if (showModal) {
            <folder-select-modal
                [folders]="folders"
                (folderSelected)="onFolderSelected($event)"
                (modalClosed)="closeModal()"
            >
            </folder-select-modal>
        }
    `,
    standalone: false
})
export class FolderSelectModalButtonComponent {
    @Input()
    folders: Folder[];
    @Input()
    disabled = false;

    @Output()
    readonly folderSelected = new EventEmitter<Folder>();

    showModal = false;

    constructor(
        private contextDataService: ContextDataService,
        public TR: TranslationService
    ) {}

    onFolderSelected(folder: Folder) {
        this.contextDataService.selectedFolder = folder;
        this.folderSelected.emit(folder);
        this.showModal = false;
    }

    closeModal() {
        this.showModal = false;
    }

    onClick() {
        if (!this.disabled) {
            this.showModal = true;
        }
    }
}
